import {
  Card, Container, ErrorMessage,
} from 'nhsuk-react-components';
import AdminCohortsSection from 'pages/admin/TeamCohortsPage/AdminCohortsSection.tsx';
import useFetchAllCohorts, {
  CohortResponse,
} from 'queries/fetch/fetchAllCohorts.ts';
import { useParams } from 'react-router-dom';
import useFetchTeamCohorts from 'queries/fetch/fetchTeamCohorts.ts';
import ProgressIndicator from 'components/ProgressIndicator';
import Back from 'components/Back';

interface ITeamCohortsPageContentProps {
  allCohortsError: Error | null;
  teamCohortsError: Error | null;
  isLoadingTeamCohorts: boolean;
  isLoadingAllCohorts: boolean;
  allCohorts?: CohortResponse;
  teamCohorts?: CohortResponse;
  teamId: string;
}

function TeamCohortsPageContent({
  allCohortsError,
  teamCohortsError,
  isLoadingTeamCohorts,
  isLoadingAllCohorts,
  allCohorts,
  teamCohorts,
  teamId,
}: ITeamCohortsPageContentProps) {
  if (isLoadingTeamCohorts || isLoadingAllCohorts) {
    return (
      <Card>
        <ProgressIndicator text="Loading cohorts..." />
      </Card>
    );
  }

  const error = allCohortsError || teamCohortsError;
  if (error) {
    return (
      <Card>
        <ErrorMessage>{error.message}</ErrorMessage>
      </Card>
    );
  }

  return (
    <AdminCohortsSection
      allCohorts={allCohorts?.cohorts.CohortRefData ?? []}
      teamCohorts={teamCohorts?.cohorts.CohortRefData ?? []}
      teamId={teamId}
    />
  );
}

function TeamCohortsPage() {
  const { teamId } = useParams() as { teamId: string };

  const {
    data: teamCohorts,
    error: teamCohortsError,
    isLoading: isLoadingTeamCohorts,
  } = useFetchTeamCohorts({ teamId });

  const {
    data: allCohorts,
    error: allCohortsError,
    isLoading: isLoadingAllCohorts,
  } = useFetchAllCohorts({ teamId });

  return (
    <Container>
      <div className="nhsuk-u-margin-top-6 nhsuk-u-margin-bottom-6">
        <Back backTo={`/admin/${teamId}/team-cohorts`} />
      </div>
      <Card>
        <>
          <h1
            role="main"
            id="maincontent"
            className="nhsuk-heading-l nhsuk-u-margin-top-0 nhsuk-u-margin-bottom-3"
          >
            Choose cohorts for the team
          </h1>
          <p>Choose one or more cohorts to assign to this team.</p>
        </>
      </Card>
      <TeamCohortsPageContent
        allCohortsError={allCohortsError}
        teamCohortsError={teamCohortsError}
        isLoadingTeamCohorts={isLoadingTeamCohorts}
        isLoadingAllCohorts={isLoadingAllCohorts}
        allCohorts={allCohorts}
        teamCohorts={teamCohorts}
        teamId={teamId}
      />
    </Container>
  );
}

export default TeamCohortsPage;
